import { enumToString, STANDARD_ACCESSORIALS } from 'clerk_common/enums';
import { CompletedFreightOrderTemplate } from 'clerk_common/templates/freight_order/types';
import { mutateByFieldTypeSync } from 'clerk_common/templates/mutate/mutateSync';
import { doesTemplatePathMatch } from 'clerk_common/templates/path';
import { FormValueChild } from 'clerk_common/templates/types';
import { isNil } from 'lodash';

export type AccessorialOption = {
  id: string;
  label: string;
};

export function getAccessorialOptions(): AccessorialOption[] {
  return STANDARD_ACCESSORIALS.map((a) => ({
    id: a,
    label: enumToString(a),
  }));
}

export function setAccessorialsInExtractedData(
  data: CompletedFreightOrderTemplate,
  accessorials: string[]
): CompletedFreightOrderTemplate {
  return mutateByFieldTypeSync(data as FormValueChild, {
    list: (child, path) => {
      const pathMatches =
        !isNil(path) &&
        doesTemplatePathMatch(path, 'accessorials', data as FormValueChild);
      if (!pathMatches) return child;

      const newAdded = accessorials.map((a) => ({
        accessorialDescription: {
          _value: a,
          _corrected: a,
          _logProbs: [],
          _display: { name: '' },
        },
      }));
      const newIdxs = accessorials.map((_, i) => `_added.${i}`);
      return { ...child, _added: newAdded, _idxs: newIdxs };
    },
  }) as CompletedFreightOrderTemplate;
}
